<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { globalCurrencyTag } from '../../../common/util';

  export let data: any;

  const { encodedContextPath } = getAppConfig();
</script>

<a class="service-link" href={encodedContextPath + (data?.algoliaUrl ? data.algoliaUrl : data.url)}>
  <div class="c_category-service--cards">
    {#if data.iconUrl}
      <div class="c_category-service--icon">
        <img src={data.iconUrl} alt="category service" />
      </div>
    {/if}
    {#if data.title}
      <div class="c_category-service--title">{data.title}</div>
    {/if}
    <div class="c_category-service--features">
      {#if data?.serviceHighlights}
        {#each data.serviceHighlights.split('|') as highlightsText}
          <div class="c_category-service--featuretext">
            {highlightsText.trim()}
          </div>
        {/each}
      {/if}
    </div>
    {#if data.subText1}
      <div class="c_category-service--highlights">{data.subText1}</div>
    {/if}
    {#if data.priceText}
      <div class="c_category-service--price">
        <span class="c_category-service--currency">{@html globalCurrencyTag}</span>
        {data.priceText}
      </div>
    {/if}
  </div>
</a>
